import { Location } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-error-page',
  standalone: true,
  imports: [MatButtonModule],
  templateUrl: './error-page.component.html',
})
export class ErrorPageComponent {
  location = inject(Location);
  private router = inject(Router);

  globalErrorMessage = environment.errorMessage;

  tryAgain() {
    this.location.back();
  }

  goHome() {
    this.router.navigate([''], { replaceUrl: true });
  }
}
